var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgPlaceholderAvatar2 = function SvgPlaceholderAvatar2(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_105_960)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.4999,
    cy: 12.4999,
    r: 12.1667,
    fill: "#755EF2",
    stroke: "#755EF2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16675 20.603V20.2193C4.16675 17.5943 9.62386 16.2719 12.3575 16.2719C15.0912 16.2719 20.5483 17.5943 20.5483 20.2193V20.6031C18.5472 22.7884 15.6194 24.1667 12.3575 24.1667C9.09571 24.1667 6.16788 22.7884 4.16675 20.603ZM12.3575 7.5C10.0948 7.5 8.26214 9.26645 8.26214 11.4474C8.26214 13.6283 10.0948 15.3947 12.3575 15.3947C14.6202 15.3947 16.4529 13.6283 16.4529 11.4474C16.4529 9.26645 14.6202 7.5 12.3575 7.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_105_960"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgPlaceholderAvatar2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/placeholder-avatar-2.e4043e371259ce10b4270dbc38cb35ae.svg";